import { buildBusinessErrorFromError, EntityKind } from '@mgdis/eu-domain';
class DocumentsRestAdapter {
    restHttpAdapter;
    constructor({ restHttpAdapter }) {
        this.restHttpAdapter = restHttpAdapter;
    }
    /**
     * Fetch document data from GED
     *
     * @param documentHref - Path of document in ged
     */
    async getDocumentAsBlob(documentHref) {
        try {
            const res = await this.restHttpAdapter.get(documentHref, { responseType: 'blob' });
            if (!(res.data instanceof Blob)) {
                return {
                    error: buildBusinessErrorFromError(new Error('Document is not a Blob type'), {
                        entityKind: EntityKind.DOCUMENT,
                    }),
                };
            }
            return { response: res.data };
        }
        catch (error) {
            return { error: buildBusinessErrorFromError(error, { entityKind: EntityKind.DOCUMENT }) };
        }
    }
}
export { DocumentsRestAdapter };
//# sourceMappingURL=documents-rest.adapter.js.map